import React, { createContext, useContext, useState } from 'react';

const BreadcrumbContext = createContext({ pageTitle: null, setPageTitle: () => {} });

export function BreadcrumbProvider({ children }) {
  const [pageTitle, setPageTitle] = useState(null);
  return (
    <BreadcrumbContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumb() {
  return useContext(BreadcrumbContext);
}
